import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/feature/JsonLd';
import HeroSection from '@/pages/home/components/HeroSection';
import CategoryGrid from '@/pages/home/components/CategoryGrid';
import ArticleSection from '@/pages/home/components/ArticleSection';
import TrustSection from '@/pages/home/components/TrustSection';
import BrandSection from '@/pages/home/components/BrandSection';
import CTASection from '@/pages/home/components/CTASection';
import FAQSection from '@/pages/home/components/FAQSection';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://hipobuyspread.autos';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Hipobuy Spreadsheet Hub',
  url: siteUrl,
  description: 'Discover the most comprehensive Hipobuy spreadsheet resources, verified product finds, QC guides, and expert buying strategies. Browse organized spreadsheets across shoes, clothing, accessories, and more.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${siteUrl}/?s={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
  publisher: {
    '@type': 'Organization',
    name: 'Hipobuy Spreadsheet Hub',
    url: siteUrl,
  },
};

export default function Home() {
  return (
    <>
      <JsonLd data={homeJsonLd} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <BrandSection />
        <ArticleSection />
        <TrustSection />
        <FAQSection />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}